import {createAction} from "redux-act";
import {ISquad} from "modules/reducers";

export const fetchSquads = createAction();
export const fetchSquadsSuccess = createAction<ISquad[]>();
export const fetchSquadsFailed = createAction<Error>();
